import ManualContainer from './ManualContainer';

export default ManualContainer;
